import { animate, useMotionValue, useTransform, motion } from 'framer-motion';
import { useEffect } from 'react';

type Props = {
  value: number;
  format: (v: number) => string;
  className?: string;
  duration?: number;
};

export function AnimatedNumber({ value, format, className, duration = 0.6 }: Props) {
  const mv = useMotionValue(value);
  const display = useTransform(mv, (v) => format(v));

  useEffect(() => {
    const controls = animate(mv, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
    });
    return controls.stop;
  }, [value, duration, mv]);

  return <motion.span className={className}>{display}</motion.span>;
}
